// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"43":"app-theme-dark0","234":"app-theme-dark1","653":"app-theme-light0","844":"app-theme-light1"}[chunkId] + "." + {"43":"4b05ac69","234":"34be32e9","653":"822b98ca","844":"ea1331c7"}[chunkId] + ".chunk.css";
};